
<style>
    .spreadsheet-read-only {
        backgroud-color:#dddddd;
    }
</style>

<template>
    <div>
        <hot-table
                ref="hotTable"
                :data="dataValue"
                :contextMenu="dataContextMenu"
                :mergeCells="dataMergeCells"
                :manualColumnResize="dataManualColumnResize"
                :rowHeaders="dataRowHeaders"
                :colHeaders="dataColHeaders"
                :settings="dataSettings"
                @afterChange="afterChange"
                licenseKey="non-commercial-and-evaluation">
        </hot-table>
    </div>
</template>

<script>
    var _self;
    import { HotTable } from '@handsontable/vue';
    export default {
        name: 'Spreadsheet',
        components: {
            HotTable
        },
        props: {
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            id: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            labelCols: {
                type: Number,
                default: 0
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            rowHeaders: {
                type: Boolean,
                default: true
            },
            colHeaders: {
                type: Boolean,
                default: true
            },
            manualColumnResize: {
                type: Boolean,
                default: true
            },
            mergeCells: {
                type: Boolean,
                default: true
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
                this.$refs.hotTable.hotInstance.render()
            },
            dataValue(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            _self = this
            this.dataValue = this.value
            this.dataRowHeaders = this.rowHeaders
            this.dataColHeaders = this.colHeaders
            this.dataManualColumnResize = this.manualColumnResize
            this.dataMergeCells = this.mergeCells
            this.$forceUpdate()
            this.$refs.hotTable.hotInstance.render()
        },
        data: () => {
            return {
                Core: window.Core,
                dataValue: [],
                dataInit: false,
                dataIsVisible: true,
                dataRowHeaders: true,
                dataColHeaders: true,
                dataManualColumnResize: true,
                dataMergeCells: true,
                dataContextMenu: {
                    callback: function (key, selection, clickEvent) {},
                    items: {
                        'row_above': {
                            name: function () {
                                return 'Insérer rangée au dessus';
                            }
                        },
                        'row_below': {
                            name: function () {
                                return 'Insérer rangée en dessous';
                            }
                        },
                        'remove_row': {
                            name: function () {
                                return 'Supprimer la rangée';
                            }
                        },
                        'col_left': {
                            name: function () {
                                return 'Insérer colonne à gauche';
                            }
                        },
                        'col_right': {
                            name: function () {
                                return 'Insérer colonne à droite';
                            }
                        },
                        'remove_col': {
                            name: function () {
                                return 'Supprimer la colonne';
                            }
                        },
                        'alignment': {
                            name: function () {
                                return 'Alignement';
                            }
                        },
                        'undo': {
                            name: function () {
                                return 'Undo';
                            }
                        },
                        'redo': {
                            name: function () {
                                return 'Redo';
                            }
                        },
                        'make_read_only': {
                            name: function () {
                                return 'Lecture seule';
                            },
                            callback(key, selections) {
                                for(let selection in selections) {
                                    selection = selections[selection]
                                    let startCol = selection.start.col
                                    let startRow = selection.start.row
                                    _self.$refs.hotTable.hotInstance.setCellMeta(startRow, startCol, 'className', 'spreadsheet-read-only');
                                }
                            }
                        },
                        'mergeCells': {
                            name: function () {
                                return 'Fusionner les cellules';
                            }
                        }
                    }
                },
                dataSettings: {
                    afterChange: (itemodificado, accionHanson)=> {
                        console.log('here')
                    }
                }
            }
        },
        computed: {},
        methods: {
            afterChange(a, b) {
                console.log(a)
            },
            chkState(val) {
                if (this.form !== undefined && this.form[val] !== undefined) {
                    const field = this.form[val]
                    return !field.$dirty || !field.$invalid
                }
            }
        }
    }
</script>